import { useConfigStore } from '../store/store';

function Logo(){
    const configThemeFolder = useConfigStore(state => state.config?.themeFolder);
    const configLogo = useConfigStore(state => state.config?.logo);

    return <img src={"/theme/" + configThemeFolder + "/" + configLogo} className='scaled-image' alt="logo" />
}
export default Logo;    